module.exports = __webpack_public_path__ + "img/w3_grid_grey.3502bff0.png";